import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ScrollSmoother from 'gsap/ScrollSmoother';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Reset native scroll
    window.scrollTo(0, 0);
    
    // Also reset GSAP ScrollSmoother if it's active
    const smoother = ScrollSmoother.get();
    if (smoother) {
      smoother.scrollTop(0);
    }
  }, [pathname]);

  return null;
}
